module.exports = __webpack_public_path__ + "static/img/Sam-Marshall.329922d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Sam-Marshall.jpg
// module id = qrFc
// module chunks = 0